import {Base} from "@/api/Base"

export class SalaryBatchAdd extends Base {
    path = "salary/batchAdd"
}